module.exports = __webpack_public_path__ + "img/borderLineWhite.72ea5296.svg";